import React, { useEffect, useState } from 'react';
import LandingBeneficio from './LandingBeneficio';

export const PantallaEstado = ({ titulo, texto, testId }) => (
  <div className="boda-landing flex min-h-screen flex-col items-center justify-center px-8 text-center" style={{ background: '#F3EFE3', color: '#3B4A3A' }} data-testid={testId}>
    <p className="text-[clamp(1.6rem,5vw,2.4rem)]">{titulo}</p>
    {texto && <p className="mt-3 max-w-md text-base" style={{ color: '#586154', fontFamily: 'system-ui, sans-serif' }}>{texto}</p>}
  </div>
);

export default function PaginaPublica({ cargar, variante, clave, campoDatos, titulo }) {
  const [estado, setEstado] = useState({ tipo: 'cargando' });

  useEffect(() => {
    let activo = true;
    cargar(clave)
      .then(d => { if (activo) setEstado({ tipo: 'ok', datos: d[campoDatos], contacto: d.contacto }); })
      .catch(err => { if (activo) setEstado({ tipo: err.response?.status === 404 ? 'no-existe' : 'error' }); });
    return () => { activo = false; };
  }, [cargar, clave, campoDatos]);

  useEffect(() => {
    if (estado.tipo === 'ok') document.title = titulo(estado.datos);
  }, [estado, titulo]);

  if (estado.tipo === 'cargando') return <PantallaEstado titulo="Cargando…" testId="landing-cargando" />;
  if (estado.tipo === 'no-existe') return <PantallaEstado titulo="Esta página no está disponible" texto="Es posible que el enlace haya cambiado o que la página aún no esté publicada." testId="landing-no-disponible" />;
  if (estado.tipo === 'error') return <PantallaEstado titulo="No pudimos cargar la página" texto="Revisa tu conexión e inténtalo de nuevo en unos segundos." testId="landing-error" />;
  return <LandingBeneficio variante={variante} datos={estado.datos} contacto={estado.contacto} />;
}
